import { CheckOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import classes from './Selectable.module.less';
import classname from 'classname';
import { Space } from 'antd';
type Props = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
};
export const Selectable = ({ children, checked, onChange }: Props) => {
  const [value, setValue] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    setValue(checked);
  }, [checked]);

  return (
    <div
      onMouseEnter={() => {
        setActive(true);
      }}
      onMouseLeave={() => {
        setActive(false);
      }}
      className={classname(classes.selectable, {
        [classes.active]: active
      })}
      onClick={() => {
        if (value) {
          return;
        }
        setValue(!value);
        onChange(!value);
      }}
      aria-checked={value}
    >
      <Space>
        <CheckOutlined />
        <div style={{ width: '100%' }}>{children}</div>
      </Space>
    </div>
  );
};
